import type { Node } from "@xyflow/react";
import type { NodeBounds } from "../comments/threadPlacement";

/** React Flow node → the plain shape the placement math takes. */
export function nodeBounds(node: Node): NodeBounds {
  return {
    id: node.id,
    x: node.position.x,
    y: node.position.y,
    width: node.measured?.width ?? node.width ?? 0,
    height: node.measured?.height ?? node.height ?? 0,
    type: node.type,
    parentId: node.parentId,
  };
}

/** Indexed by id, for the ancestor walk `resolvePinPosition` performs. */
export function nodeBoundsById(nodes: Node[]): Map<string, NodeBounds> {
  return new Map(nodes.map((n) => [n.id, nodeBounds(n)]));
}
